// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-1780c6c5]{-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
